var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgStarDefault2456191B = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 27.39L7.42052 33.312L9.78302 21.42L0.882019 13.188L12.9225 11.76L18 0.75L23.0775 11.76L35.118 13.188L26.217 21.42L28.5795 33.312L18 27.39ZM18 23.952L24.3705 27.5175L22.9485 20.358L28.308 15.4005L21.0585 14.541L18.0015 7.9125L14.943 14.5425L7.69352 15.4005L13.053 20.358L11.631 27.5175L18 23.952Z",
    fill: "#9AACBB",
    fillOpacity: 0.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStarDefault2456191B);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "svg/gwwjzjmh5hqo.svg";